'use client';

import { c as _c } from "react/compiler-runtime";
import { useEnv } from "@/components/providers/EnvProvider";
import "./ContactUsForm.css";
interface ContactUsFormProps {
  formRightRef?: React.RefObject<HTMLDivElement | null>;
}
const ContactUsForm = t0 => {
  const $ = _c(2);
  const {
    CONTACT_US_FORM_LINK
  } = useEnv();
  if (!CONTACT_US_FORM_LINK) {
    return null;
  }
  let t1;
  if ($[0] !== CONTACT_US_FORM_LINK) {
    t1 = <div className="contact-us-form-container"><iframe src={CONTACT_US_FORM_LINK} className="zoho-iframe" width="100%" height="800px" allowFullScreen={true} /></div>;
    $[0] = CONTACT_US_FORM_LINK;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default ContactUsForm;